import { involucro, involucroTesto } from './layout.ts';
import { applicaMergeTag } from './mergeTags.ts';
import { renderBlocchi, renderBlocchiTesto } from './render.ts';
import type { Destinatario, DocumentoEmail, EmailResa, RenderContext } from './types.ts';

export * from './types.ts';
export * from './escape.ts';
export * from './mergeTags.ts';
export { documentoVuoto, raccogliUrl } from './render.ts';

/**
 * Da documento a email pronta, con i segnaposto ancora dentro.
 * Serve all'anteprima e come passo intermedio dell'invio.
 */
export function renderEmail(
  documento: DocumentoEmail,
  ctx: RenderContext,
  preheader?: string
): EmailResa {
  return {
    html: involucro(renderBlocchi(documento, ctx), ctx, preheader),
    testo: involucroTesto(renderBlocchiTesto(documento, ctx), ctx),
  };
}

export interface EmailPerDestinatario extends EmailResa {
  oggetto: string;
  sconosciuti: string[];
  vuoti: string[];
}

/**
 * Da documento a email pronta per una persona precisa.
 * E' cio' che chiama il motore al momento dell'invio: il risultato viene
 * congelato nel messaggio, cosi' quello che e' partito resta consultabile
 * identico anche se domani il contatto cambia nome.
 */
export function renderPerDestinatario(
  documento: DocumentoEmail,
  oggetto: string,
  destinatario: Destinatario,
  ctx: RenderContext,
  preheader?: string
): EmailPerDestinatario {
  const base = renderEmail(documento, ctx, preheader);

  const html = applicaMergeTag(base.html, destinatario, ctx);
  const testo = applicaMergeTag(base.testo, destinatario, ctx, { escapa: false });
  const titolo = applicaMergeTag(oggetto, destinatario, ctx, { escapa: false });

  return {
    html: html.testo,
    testo: testo.testo,
    oggetto: titolo.testo,
    sconosciuti: [...new Set([...html.sconosciuti, ...titolo.sconosciuti])],
    vuoti: [...new Set([...html.vuoti, ...titolo.vuoti])],
  };
}
